import PDFReportsExtensions from './pdf-report';
export default [PDFReportsExtensions];
